import { render, staticRenderFns } from "./RightNavBar.vue?vue&type=template&id=573704b0&"
import script from "./RightNavBar.vue?vue&type=script&lang=js&"
export * from "./RightNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports